import { connectRealtimeChannel } from '@dotstorming/realtime';
import { dotvotingApi } from './dotvotingApi';

export type BoardSocketEvent = {
  topic: string;
  action: string;
  [key: string]: unknown;
};

let client: ReturnType<typeof connectRealtimeChannel<BoardSocketEvent>> | null = null;
let currentBoardId: string | null = null;

export const subscribeToBoardSocket = (
  boardId: string,
  onEvent: (event: BoardSocketEvent) => void
) => {
  client?.close();
  currentBoardId = boardId;
  client = connectRealtimeChannel<BoardSocketEvent>({
    kind: 'dotvoting',
    id: boardId,
    getToken: async () => (await dotvotingApi.getRealtimeToken(boardId)).token,
    onMessage: onEvent,
    onContinuityLost: () => window.location.reload(),
  });
  return () => {
    if (currentBoardId === boardId) {
      client?.close();
      client = null;
      currentBoardId = null;
    }
  };
};

export const publishBoardSocketEvent = (event: BoardSocketEvent) => {
  if (client && currentBoardId === event.topic) client.publish(event);
};
